import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIPostFolder, BackendFolder, Folder } from "@dataRoomSetup/models";
import { ThunkApiConfig } from "@shared/models/redux";
import { fetchInitialFolders } from "@dataRoomSetup/store/fetchInitiaFolder";
import { fetchInitialFoldersList } from "@dataRoomSetup/store/fetchFolderList";
import { postDataroomsetFolders } from "./postDataRoomSetFolders";

export const fetchInitialFoldersThunk = createAsyncThunk<
  BackendFolder[],
  { id: number; body?: APIPostFolder[] },
  ThunkApiConfig
>("folders/fetchInitialFolders", async ({ id, body }, { dispatch, rejectWithValue, getState }) => {
  const {
    user: { data: userData },
  } = getState();

  try {
    const response = await dispatch(fetchInitialFolders(id, userData!.id, body));

    const data = response as BackendFolder[];

    return data as Folder[];
  } catch (error) {
    return rejectWithValue("Failed to fetch Documents");
  }
});

export const fetchInitialFoldersListThunk = createAsyncThunk<string[], void, ThunkApiConfig>(
  "folders/fetchInitialFoldersList",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await dispatch(fetchInitialFoldersList());

      const data = response;

      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch Documents");
    }
  }
);

export const postDataRoomsetFoldersThunk = createAsyncThunk<
  BackendFolder[],
  { id: number; body?: APIPostFolder[] },
  ThunkApiConfig
>("folders/postDataRoomsetFolders", async ({ id, body }, { dispatch, rejectWithValue, getState }) => {
  const {
    user: { data: userData },
  } = getState();

  try {
    const response = await dispatch(postDataroomsetFolders(id, userData!.id, body));

    const data = response as BackendFolder[];

    return data as Folder[];
  } catch (error) {
    return rejectWithValue("Failed to fetch Documents");
  }
});
